var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    fill: "none",
    viewBox: "0 0 14 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.294 20q-.674 0-.99-.307Q0 19.4 0 18.748V1.252Q0 .6.304.307.62 0 1.294 0h2.827q.674 0 .977.307.317.293.317.945v17.496q0 .652-.317.945-.303.307-.977.307zm8.598 0q-.686 0-1.003-.307-.304-.293-.304-.945V1.252q0-.652.304-.945Q9.206 0 9.892 0h2.814q.673 0 .977.307Q14 .6 14 1.252v17.496q0 .652-.317.945-.304.307-.977.307z"
  })));
};
export default SvgPause;